"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselWidget = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alphaLion = _interopRequireDefault(require("../../assets/images/alphaLion.png"));
var _core = require("@material-ui/core");
var _theme = require("../../theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    container: {
      position: 'relative',
      display: 'flex',
      alignItems: 'flex-start',
      height: '100%'
    },
    images: {
      width: '700px',
      height: 'auto',
      minHeight: '715px',
      backgroundColor: 'black',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      borderRadius: '24px',
      objectFit: 'contain',
      maxWidth: '100%',
      maxHeight: 'calc(100vh - 64px)',
      backgroundPosition: 'center'
    },
    btnContainer: {
      position: 'absolute',
      left: '72px',
      right: '72px',
      textAlign: 'center',
      display: 'flex',
      gap: '8px',
      padding: '0px',
      boxSizing: 'border-box',
      bottom: '24px'
    },
    '@media (min-width: 1920px)': {
      images: {
        width: '700px',
        maxHeight: 'calc(100vh - 148px)'
      }
    },
    '@media (max-width: 1024px) and (min-width: 768px)': {
      images: {
        width: '100%',
        height: 'auto'
      }
    },
    '@media (max-width: 767px)': {
      images: {
        width: '100%',
        height: 'auto'
      }
    }
  };
}, {
  name: 'carouselWidget'
});
var CarouselWidget = function CarouselWidget(_ref) {
  var images = _ref.images,
    _ref$autoPlayInterval = _ref.autoPlayInterval,
    autoPlayInterval = _ref$autoPlayInterval === void 0 ? 6000 : _ref$autoPlayInterval,
    height = _ref.height,
    width = _ref.width,
    description = _ref.description,
    style = _ref.style;
  var classes = useStyles();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var getImageUrl = function getImageUrl(item) {
    if (images.length > 0 && item !== null && item !== void 0 && item.fileUrl) {
      return encodeURI(item === null || item === void 0 ? void 0 : item.fileUrl);
    } else {
      return _alphaLion["default"];
    }
  };
  var handleImageClick = (0, _react.useCallback)(function () {
    var item = images[currentIndex];
    if (_typeof(item) === 'object' && item !== null && item !== void 0 && item.href) {
      window.open(item === null || item === void 0 ? void 0 : item.href, '_blank', 'noopener,noreferrer');
    }
  }, [currentIndex, images]);
  var nextImage = (0, _react.useCallback)(function () {
    setCurrentIndex(function (prevIndex) {
      return (prevIndex + 1) % images.length;
    });
  }, [images.length]);
  var setImageIndex = function setImageIndex(index) {
    setCurrentIndex(index);
  };
  (0, _react.useEffect)(function () {
    if (images.length > 1) {
      var autoPlay = setInterval(nextImage, autoPlayInterval);
      return function () {
        return clearInterval(autoPlay);
      };
    }
  }, [autoPlayInterval, images.length, nextImage, currentIndex]);
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    height: height,
    width: width,
    className: classes.container,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: getImageUrl(images[currentIndex]),
    alt: description !== null && description !== void 0 ? description : '',
    className: classes.images,
    onClick: handleImageClick,
    style: {
      cursor: _typeof(images[currentIndex]) === 'object' && images[currentIndex].href ? 'pointer' : 'default'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.btnContainer
  }, images === null || images === void 0 ? void 0 : images.map(function (img, index) {
    return /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      key: index,
      onClick: function onClick(e) {
        e.stopPropagation();
        setImageIndex(index);
      },
      style: {
        padding: 0,
        backgroundColor: currentIndex === index ? '#FFFFFF' : 'grey',
        color: 'white',
        borderRadius: '5px',
        width: "calc((100% - ".concat(8 * images.length, "px) / ").concat(images.length, ")"),
        height: '8px',
        opacity: currentIndex === index ? '75%' : '25%'
      }
    });
  })));
};
exports.CarouselWidget = CarouselWidget;